/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Utilities" />
import { AccessTokenRequestType, ServiceEndpoint, ServiceEndpointDetails } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { IVssPageContext } from "VSS/Platform/Context";

export function safeParseJson(input?: string): any {
    let output = {};
    if (input) {
        try {
            output = JSON.parse(input) || {};
        }
        catch (e) { }
    }

    return output;
}

export function isUrlValid(url?: string): boolean {
    return !!url && new RegExp("^.+://.+$").test(url);
}

export function copyToClipboard(text: string) {
    const listener = (e: ClipboardEvent) => {
        if (e.clipboardData) {
            e.clipboardData.setData("text/plain", text);
            e.preventDefault();
        }
    };

    // Add a listener to the copy event, and add it to the clipboard. Then remove the handler immediately, as it prevents default
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
}

export function getResourceGroupFromClusterId(clusterId: string): string | undefined {
    if (!clusterId) {
        return;
    }

    const resourceGroupMatch = clusterId.match(/\/resourcegroups\/([-\w\._\(\)]+)\//i);
    return resourceGroupMatch ? resourceGroupMatch[1] : undefined;
}

export function setAuthInEnpointRequest(pageContext: IVssPageContext, serviceEndpoint: ServiceEndpointDetails | ServiceEndpoint, accessTokenKey: string, updateFetchingMethod: boolean): void {
    const tokenParameterKey = serviceEndpoint.type === "Kubernetes" ? "azureAccessToken" : "accessToken";
    serviceEndpoint.authorization.parameters[tokenParameterKey] = accessTokenKey;

    if (updateFetchingMethod) {
        serviceEndpoint.authorization.parameters["accessTokenFetchingMethod"] = AccessTokenRequestType.Oauth.toString();
    }
}

export namespace PageKey {
    export const GetServiceEndpointsView = "get-service-endpoints";
    export const AddKubernetesResourceView = "add-kubernetes-service-group";
}

export namespace KubernetesProviderType {
    export const AzureKubernetesServiceProvider = "AzureKubernetesServiceProvider";
    export const CustomProvider = "CustomProvider";
}

export namespace KubernetesEndpointAuthorizationType {
    export const AzureSubscription = "AzureSubscription";
    export const ServiceAccount = "ServiceAccount";
}

export namespace KubernetesEvents {
    export const CLUSTERS_FETCHED_EVENT = "clusters_fetched_event";
    export const NAMESPACES_FETCHED_EVENT = "namespaces_fetched_event";
}

export namespace Action {
    export const AddCustomProvider = "AddCustomProvider";
    export const AddAKSResProvider = "AddAKSResProvider";
    export const AddAKSCluster = "AddAKSCluster";
    export const AddAKSNamespace = "AddAKSNamespace";
}

export const KubernetesEndpointType = "kubernetes";
